import { factory as biLoggerFactory, } from '@wix/fe-essentials-editor/bi';
let loggerInstance;
const BI_PLATFORM_HOST_INTEGRATION_ENDPOINT = 'editor-platform';
const BI_SRC = 110;
export const BI_DEPRECATED_COMPLEX_SELECTOR = 3134;
export function createBiLogger({ userId, metaSiteId, editorType, sdkInfo, }) {
    loggerInstance = biLoggerFactory({
        endpoint: BI_PLATFORM_HOST_INTEGRATION_ENDPOINT,
    })
        .updateDefaults({
        src: BI_SRC,
        msid: metaSiteId,
        uuid: userId,
        sdkVersion: sdkInfo?.sdkVersion,
        editorType,
    })
        .logger();
    return loggerInstance;
}
export function reportBi(evid, event) {
    if (loggerInstance) {
        const eventParams = { ...event, evid };
        loggerInstance.log(eventParams);
    }
}
//# sourceMappingURL=bi.js.map